import { defineStore } from 'pinia'
import { useApi } from '~/composables/useApi'

export const useCountriesStore = defineStore('countries', {
  state: () => ({
    countries: {
      loading: false,
      data: [],
    },
  }),

  actions: {
    async loadCountries () {
      this.countries.loading = true
      try {
        const resp = await useApi('countries.json')
        this.countries.data = resp.response.countries
      } finally {
        this.countries.loading = false
      }
    },

  },
})
